export class HistoricalRoadReference {
    constructor(
        readonly roadReference: string,
        readonly fromDate: string,
        readonly toDate: string | null,
        readonly roadLinkPosition: string,
        readonly coordinate: string | null,
        readonly currentVegsystemreferanse: string | null
    ) {}
}
